module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch04"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch_04"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("FOUR")])])])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Almond Pie")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("THE DEEP SOUTH IS STILL A MYSTERY. IT IS EVEN A MYSTERY TO")]), _vm._v(" those who live there. Live oaks trailing Spanish moss whisper and move around during the night. Sometimes they move next door. A mystery. But that’s the way things are.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There are bays and bayous and runoff creeks that don’t run but meander through swamp grass into deep woods where panthers and bears still live. Flowers no one has ever seen or cataloged bloom here; alligators and cottonmouths slide silently through the water.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It is here that Thomas Sullivan brings his bride, Sarah, in June 1927. Here to Harlow, Alabama, with Mobile Bay in front of them and the wild woods behind them. They come down the shell road in their new Model T that they paid $250 for yesterday in Mobile. Thomas has already changed one flat tire. They come to the water, to a narrow beach that magnolias and palmettos are trying to claim. If they turn left, they will have dinner at the Grand Hotel where guests are ferried in from Mobile. If they turn right, they will "), _c('a', {
    attrs: {
      "id": "page13"
    }
  }), _vm._v("climb the only hill on Mobile Bay and look out over the water, dotted by sailboats. They will get out of the car and smell honeysuckle, magnolia, and the strong seminal odor of the bay.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Let’s see what’s up there.” Thomas points to his right. And that decision, of course, makes all the difference.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Two houses have already been built on the red clay bluff overlooking the water. Wooden steps lead from the front yard of each down to a pink strip of beach where a blue heron wades in a tidal pool. In the distance, the city of Mobile rises like a mirage.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Thomas, who is from Massachusetts, has never seen such exotic lushness. He equates it with Sarah who stands beside him in a peach-colored voile dress.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Dear God!” he says, looking around, afraid he will miss something.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sarah smiles at Thomas’s reaction. Her front teeth are slightly crooked; freckles are scattered across her nose. She is beautiful.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I want a house right here,” Thomas says.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Fine,” Sarah agrees. She has been married five days. She takes Thomas’s arm in both her hands. It is warm and hard. “But right now we’d better go to dinner. They’ll run out of almond pie for sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("And then Thomas Sullivan does something that delights his new wife. “Hold these,” he says. He hands Sarah his glasses and then does cartwheels down the beach. And that is what Sarah will remember most about this day, the cartwheels and a boat with a vivid blue sail that draws a line across the horizon.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e302beba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter04.vue
// module id = 81
// module chunks = 0